import {
	Fragment,
	PropsWithChildren,
	ReactElement
} from "react";

type RepeatProps = {
	amount: number;
};

export const Repeat = (props: PropsWithChildren<RepeatProps>): ReactElement => {
	const { amount, children } = props;

	return (
		<>
			{[...new Array(amount)]
				.map((_, i) => (<Fragment key={i}>{children}</Fragment>))
			}
		</>
	);
};

Repeat.displayName = "Repeat";
